export enum TvIcon {
	ACCESSIBILITY_AUDITIVE = 'accessibility-auditive',
	ACCESSIBILITY_DEMENTIA = 'accessibility-dementia',
	ACCESSIBILITY_MENTAL = 'accessibility-mental',
	ACCESSIBILITY_MOTOR = 'accessibility-motor',
	ACCESSIBILITY_VISUAL = 'accessibility-visual',
	ARROW = 'arrow',
	BUILDING = 'building',
	CHECKMARK = 'checkmark',
	CHECKMARK_SLIM = 'checkmark-slim',
	CHEVRON = 'chevron',
	CLOSE = 'close',
	DATE = 'date',
	DISKETTE = 'diskette',
	DOWNLOAD = 'download',
	EDIT = 'edit',
	EXCLAMATION = 'exclamation',
	EXTERNAL_LINK = 'external-link',
	EYE = 'eye',
	FACEBOOK = 'facebook',
	FILE = 'file',
	HEART = 'heart',
	HEART_FILLED = 'heart-filled',
	HELP = 'help',
	IMAGES = 'images',
	INFO = 'info',
	INSTAGRAM = 'instagram',
	LINE = 'line',
	LOADER = 'loader',
	LOCATION_PIN = 'location-pin',
	LOCATION_PIN_ALT = 'location-pin-alt',
	LT_BED_AND_BREAKFAST = 'lt-bed-and-breakfast',
	LT_CAMPING = 'lt-camping',
	LT_GENERIC_ROOM = 'lt-generic-room',
	LT_GENERIC_TERRAIN = 'lt-generic-terrain',
	LT_HOLIDAY_COTTAGE = 'lt-holiday-cottage',
	LT_HOLIDAY_PARK = 'lt-holiday-park',
	LT_HOSTEL = 'lt-hostel',
	LT_HOTEL = 'lt-hotel',
	LT_YOUTH_ACCOMMODATION = 'lt-youth-accommodation',
	MAIL = 'mail',
	MAP = 'map',
	PAPERCLIP = 'paperclip',
	PENCIL = 'pencil',
	PERSON = 'person',
	PHONE = 'phone',
	PLUS = 'plus',
	PROFILE = 'profile',
	QUESTION_CIRCLE = 'question-circle',
	SEARCH = 'search',
	SHARE = 'share',
	SQUARES = 'squares',
	TAG = 'tag',
	TRASH = 'trash',
	TRIANGLE = 'triangle',
	VIDEO = 'video',
	WARNING = 'warning',
	WORLD = 'world',
}
